import * as Sentry from '@sentry/sveltekit';
import { handleErrorWithSentry } from '@sentry/sveltekit';
import { config as zodConfig } from 'zod';

// NOTE: address strict CSP (no 'unsafe-eval')
zodConfig({ jitless: true });

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  tracesSampleRate: 0.1,
  sendDefaultPii: false,
  environment: import.meta.env.VITE_ENVIRONMENT,
  enabled: import.meta.env.VITE_ENVIRONMENT !== 'development',
  ignoreErrors: [
    'NetworkError',
    'AbortError',
    'Load failed',
    'Failed to fetch',
  ],
});

export const handleError = handleErrorWithSentry();
